module.exports = __webpack_public_path__ + "static/img/main.648e1c29.jpg";